import classNames from 'classnames';
import { type ReactNode, isValidElement } from 'react';
import { TextBase, TextLargeParagraph } from '../Typography';

export interface EmptyViewProps {
  title?: string | ReactNode;
  message?: string | ReactNode;
  illustration?: ReactNode;
  noBg?: boolean;
  noPadding?: boolean;
  small?: boolean;
}

export const EmptyView = ({
  title,
  message,
  illustration,
  noBg,
  noPadding,
  small,
}: EmptyViewProps) => {
  return (
    <div
      className={classNames(
        'w-full  flex flex-col justify-center items-center rounded-md',
        noBg ? '' : 'bg-ds-accent3-100',
        noPadding ? '' : 'p-20 h-full'
      )}
    >
      <div className={classNames(small ? 'mb-2.5' : 'mb-7')}>
        {illustration}
      </div>
      {title && (
        <div
          className={classNames('text-center', {
            'mb-1.5': small,
            'mb-3': !small,
          })}
        >
          {isValidElement(title) ? (
            title
          ) : (
            <TextLargeParagraph
              color="text-ds-natural-600"
              label={title}
            />
          )}
        </div>
      )}
      {message && (
        <div className="text-center">
          {isValidElement(message) ? (
            message
          ) : (
            <TextBase
              label={message}
              color="text-ds-natural-300"
            />
          )}
        </div>
      )}
    </div>
  );
};
